"use client";

import { CircleAlert as AlertCircle, Compass, Languages, MapPin, ShieldCheck, Wifi } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PracticeAreasList() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const guides = [{
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/business_formation_law.webp",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/business_formation_law.webp-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/business_formation_law.webp-wvc-sizes",
      alt: "法律書類が置かれた専門的なオフィス環境"
    },
    icon: Compass,
    readTime: "取扱分野 · ビジネス",
    titleStart: "事業・法人設立",
    titleAccent: "",
    titleEnd: "・所有権",
    excerpt: "法人設立、所有権の設計、重要な契約書の作成など、事業の長期的な発展に向けた法的サポートを提供します。"
  }, {
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/real_estate_law.webp",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/real_estate_law.webp-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/real_estate_law.webp-wvc-sizes",
      alt: "現代的な不動産物件の外観"
    },
    icon: ShieldCheck,
    readTime: "取扱分野 · 不動産",
    titleStart: "不動産取引",
    titleAccent: "",
    titleEnd: "・所有権移転",
    excerpt: "不動産取引に関する法的サポートを提供し、安全な所有権移転と明確な権利関係の確保を支援します。"
  }, {
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/estate_planning_law.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/estate_planning_law.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/estate_planning_law.png-wvc-sizes",
      alt: "法律書類と万年筆"
    },
    icon: MapPin,
    readTime: "取扱分野 · ESTATE",
    titleStart: "Estate Planning・遺言",
    titleAccent: "",
    titleEnd: "・信託",
    excerpt: "遺言書、委任状、医療指示書などを含むEstate Planningを通じて、ご家族の将来を守るための法的サポートを提供します。"
  }, {
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/probate_law_guidance.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/probate_law_guidance.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/probate_law_guidance.png-wvc-sizes",
      alt: "机上のガベルと法の天秤"
    },
    icon: Languages,
    readTime: "取扱分野 · PROBATE",
    titleStart: "Probate 初期確認",
    titleAccent: "",
    titleEnd: "・手続サポート",
    excerpt: "Personal RepresentativeがProbate手続を進める際に必要となる法的事項について、明確かつ専門的なサポートを提供します。"
  }, {
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/attorney_fee_expert.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/attorney_fee_expert.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/attorney_fee_expert.png-wvc-sizes",
      alt: "法律書籍が置かれた法廷"
    },
    icon: AlertCircle,
    readTime: "取扱分野 · HEARINGS",
    titleStart: "Attorney’s Fee Hearings",
    titleAccent: "",
    titleEnd: "・Expert Witness",
    excerpt: "弁護士費用の妥当性が争点となるAttorney’s Fee Hearingsにおいて、適正かつ正確な弁護士費用評価のための専門家証言を提供します。"
  }, {
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/business_litigation_law.webp",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/business_litigation_law.webp-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/business_litigation_law.webp-wvc-sizes",
      alt: "専門的な法律相談"
    },
    icon: Wifi,
    readTime: "取扱分野 · 訴訟",
    titleStart: "選択的なビジネス訴訟",
    titleAccent: "",
    titleEnd: "対応",
    excerpt: "当事務所が受任する特定のビジネス訴訟案件について、依頼者の利益を守るため、専門的かつ的確な法的対応を行います。"
  }];
  return <section data-section-id="6321" id="practiceareaslist" className="bg-background py-24 md:py-36 text-foreground">
      <div className="mx-auto max-w-[1320px] px-5 md:px-10">
        <div ref={header.ref} className={`mx-auto max-w-[720px] text-center transition-all duration-[700ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <p className="font-sans text-[clamp(0.6875rem,0.78vw,0.75rem)] font-medium uppercase text-muted-foreground" style={{
          letterSpacing: "0.18em"
        }}>
            法律サービス
          </p>

          <h2 className="mt-6 font-serif text-foreground" style={{
          fontSize: "clamp(2rem, 4vw, 3.5rem)",
          fontWeight: 350,
          letterSpacing: "-0.02em",
          lineHeight: 1.06
        }}>
            重要な{" "}
            <em className="font-serif text-primary not-italic" style={{
            fontStyle: "italic",
            fontSize: "clamp(2.25rem, 4.5vw, 4rem)",
            fontWeight: 400
          }}>
              転機
            </em>{" "}
            と成長を支える法律相談
          </h2>

          <p className="mt-8 font-serif text-muted-foreground" style={{
          fontSize: "clamp(1.125rem, 1.5vw, 1.3125rem)",
          fontWeight: 380,
          letterSpacing: "-0.005em",
          lineHeight: 1.55
        }}>
            南フロリダで培った経験をもとに、お客様にとって重要な法的事項をサポートします。
          </p>
        </div>

        <div className="mt-20 md:mt-24 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16 md:gap-y-20">
          {guides.map((guide, i) => {
          const Icon = guide.icon;
          const isEven = i % 2 === 1;
          return <GuideCard key={i} data-index={i} guide={guide} Icon={Icon} isEven={isEven} />;
        })}
        </div>
      </div>
    </section>;
}
type GuideCardProps = {
  guide: {
    image: {
      src: string;
      srcset: string;
      sizes: string;
      alt: string;
    };
    readTime: string;
    titleStart: string;
    titleAccent: string;
    titleEnd: string;
    excerpt: string;
  };
  Icon: React.ComponentType<{
    className?: string;
    strokeWidth?: number;
  }>;
  isEven: boolean;
  "data-index"?: number;
};
function GuideCard({
  guide,
  Icon,
  isEven,
  ...rest
}: GuideCardProps) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <article ref={ref} data-index={rest["data-index"]} className={`group flex flex-col transition-all duration-[700ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} ${isEven ? "md:mt-12" : ""}`}>
      <div className="relative overflow-hidden rounded-md">
        <div className="aspect-[16/10] w-full overflow-hidden">
          <img src={guide.image.src} data-wvc-srcset={guide.image.srcset} data-wvc-sizes={guide.image.sizes} alt={guide.image.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.03]" />
        </div>

        <div className="absolute bottom-4 left-4 transition-transform duration-[600ms] ease-out group-hover:scale-[1.08]">
          <Icon className="h-7 w-7 text-primary" strokeWidth={1.25} />
        </div>
      </div>

      <div className="mt-8">
        <p className="font-mono text-[0.75rem] text-muted-foreground" style={{
        letterSpacing: "0.08em"
      }}>
          {guide.readTime}
        </p>

        <h3 className="mt-4 font-serif text-foreground" style={{
        fontSize: "clamp(1.5rem, 2.4vw, 2rem)",
        fontWeight: 420,
        letterSpacing: "-0.015em",
        lineHeight: 1.15
      }}>
          {guide.titleStart}{" "}
          {guide.titleEnd ? <> {guide.titleEnd}</> : null}
        </h3>

        <p className="mt-5 font-default text-foreground/80" style={{
        fontSize: "clamp(0.9375rem, 1.1vw, 1rem)",
        fontWeight: 400,
        lineHeight: 1.65,
        display: "-webkit-box",
        WebkitLineClamp: 3,
        WebkitBoxOrient: "vertical",
        overflow: "hidden"
      }}>
          {guide.excerpt}
        </p>

        <div className="mt-6">
          <Link to="/ContactUsPage" className="inline-flex items-baseline font-default text-primary hover:text-primary/80 transition-colors duration-200" style={{
          fontSize: "0.9375rem",
          fontWeight: 500
        }}>
            <span className="border-b border-primary pb-0.5">
              詳しく見る
            </span>

            <span className="ml-2 transition-transform duration-200 group-hover:translate-x-1.5">
              {"\u2192"}
            </span>
          </Link>
        </div>
      </div>
    </article>;
}